export default {
	init($) {

		const updateActiveClass = () => {
			$('#shipping_method .shipping_method').each(function () {
				const thisInput = $(this) // Get the associated label
				if (thisInput.is(':checked')) {
					thisInput.addClass('checked') // Add active class to the label of the checked radio
				} else {
					thisInput.removeClass('checked') // Remove active class from other labels
				}
			})
		}
	
		$(document).on('updated_checkout', function () {
			updateActiveClass()
		  })
		
		updateActiveClass()
	}
}